module.exports = __webpack_public_path__ + "img/HQ-OA-360V06NL.37f9d118.jpg";